Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    expanderMobileSpacingInset: 16,
    expanderMobileTitleHeight: 48,
    expanderMobileTitleFontSize: 16,
    expanderMobileTitleBackgroundColorPressed: tokens.themeActionNeutralSelected,
    expanderMobileValueFontSize: 14,
    expanderMobileForegroundColorDefaultDefault: tokens.themeInkDefault,
    expanderMobileForegroundColorDefaultDisabled: tokens.themeInkDisabled,
    expanderMobileForegroundColorInlineDefault: tokens.themeActionPrimaryDefault,
    expanderMobileForegroundColorInlinePressed: tokens.themeActionPrimaryPressed,
    expanderMobileForegroundColorInlineDisabled: tokens.themeActionPrimaryDisabled,
    expanderSpacingVertical: 10,
    expanderSpacingHorizontal: 20,
    expanderForegroundColorDefaultDefault: tokens.themeInkDefault,
    expanderForegroundColorDefaultHover: tokens.themeActionPrimaryHover,
    expanderForegroundColorDefaultPressed: tokens.themeActionPrimaryPressed,
    expanderForegroundColorDefaultDisabled: tokens.themeActionPrimaryDisabled,
    expanderForegroundColorAccentDefault: tokens.themeActionPrimaryDefault,
    expanderForegroundColorAccentHover: tokens.themeActionPrimaryHover,
    expanderForegroundColorAccentPressed: tokens.themeActionPrimaryPressed,
    expanderForegroundColorAccentDisabled: tokens.themeActionPrimaryDisabled,
    expanderBackgroundColorBox: tokens.themePageDefault,
    expanderBorderWidth: 1,
    expanderBorderColor: tokens.themeBorderDefault,
    expanderBorderRadiusDefault: 0,
    expanderBorderRadiusBox: 4,
    expanderIconMotionDelay: "100ms",
    expanderIconMotionDuration: "200ms",
    expanderIconMotionFunction: "ease",
    expanderContentMotionDelay: "100ms",
    expanderContentMotionDuration: "200ms",
    expanderContentMotionFunction: "ease"
  }
};